import { useEffect, useState } from 'react';

// auto generate object url and release object url
function useObjectUrl(content) {
  const [objectURL, setObjectURL] = useState('');

  useEffect(() => {
    if (content) {
      URL.revokeObjectURL(objectURL);
      setObjectURL(URL.createObjectURL(content));
    }
  }, [content]);
  useEffect(
    () => () => {
      URL.revokeObjectURL(objectURL);
    },
    [objectURL],
  );

  return objectURL;
}

export default useObjectUrl;
